import jwtDecode from "jwt-decode";
import moment from "moment";

const state = {
  OAuthUser: null, // User info returned by Identity Server
  IsImpersonatingUser: false, // Specifies if the current user is impersonating another user
  IsImpersonationSupported: true, // Set to false, if this project doesnt support impersonation
  ShowSessionExpirationModal: false // Show session expiration modal when silent renew fails
};

const getters = {
  OAuthUser(state) {
    return state.OAuthUser;
  },
  AccessToken(state) {
    return state.OAuthUser ? state.OAuthUser.access_token : null;
  },
  AuthorizationHeader(state) {
    return state.OAuthUser ? "Bearer " + state.OAuthUser.access_token : null;
  },
  ImpersonationInfo(state) {
    try {
      if (!state.IsImpersonatingUser) return null;

      let decodedAccessToken = jwtDecode(state.OAuthUser.access_token);
      let expirationTime = moment.unix(decodedAccessToken.exp);

      let impersonationInfo = {
        IsImpersonatingUser: state.IsImpersonatingUser,
        OriginalUsername: decodedAccessToken.impersonating_aa_username,
        ExpirationTime: expirationTime
      };

      return impersonationInfo;
    } catch (err) {
      console.log("Error generating impersonation info: ", err);
      return null;
    }
  },
  SessionExpirationModalDuration(state) {
    return 300; // Duration (in seconds) to show the session expiration modal before redirecting the user to login site
  }
};

const actions = {
  updateOAuthUser(context, user) {
    context.commit("updateOAuthUser", user);
  },
  toggleIsImpersonatingUser(context, value) {
    context.commit("toggleIsImpersonatingUser", value);
  },
  toggleSessionExpirationModal(context, value) {
    context.commit("toggleSessionExpirationModal", value);
  }
};

const mutations = {
  updateOAuthUser(state, user) {
    state.OAuthUser = user;
  },
  toggleIsImpersonatingUser(state, value) {
    state.IsImpersonatingUser = value;
  },
  toggleSessionExpirationModal(state, value) {
    state.ShowSessionExpirationModal = value;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/Authentication.js